export default __webpack_public_path__ + "static/media/img_programa_paciente.c18607f7.svg";